import {break_lg, break_sm} from "../../js/constants";
import {Controller, EffectFade, Navigation, Swiper, Thumbs} from "swiper/dist/js/swiper.esm";

Swiper.use([Navigation, EffectFade, Thumbs, Controller]);

export function initSlider($container) {
  const $slider = $container.querySelector('.productSliderBig');
  const $thumbs = $container.querySelector('.productSliderThumbs');
  if (!$slider) return;
  if (!$thumbs) return;

  let slidesPerView = 4;
  if (window.innerWidth <= break_sm) {
    slidesPerView = 3.4;
  }
  let slidesPerViewInteger = parseInt(slidesPerView);

  const thumbsLength = $thumbs.querySelectorAll('.swiper-slide').length;
  if (thumbsLength > slidesPerViewInteger) {
    $thumbs.classList.add('has-many-slides');
  }
  if ($thumbs.querySelectorAll('.swiper-slide').length === 1) {
    $thumbs.parentNode.removeChild($thumbs);
    return;
  }

  const thumbs = new Swiper($thumbs, {
      speed: 500,
      slidesPerView,
      loop: thumbsLength > slidesPerViewInteger,
      loopedSlides: 5,
      spaceBetween: 22,
      centeredSlides: thumbsLength > slidesPerViewInteger,
      slideToClickedSlide: true,
      navigation: {
        nextEl: $thumbs.querySelector('.swiper-button-next'),
        prevEl: $thumbs.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        [break_lg]: {
          spaceBetween: 23
        },
        [break_sm]: {
          spaceBetween: 8,
          slidesPerView: 3.4,
          centeredSlides: false,
          slidesOffsetBefore: thumbsLength > slidesPerViewInteger ? 60 : 0
        },
      }
    }
  );
  const slider = new Swiper($slider, {
      speed: 500,
      slidesPerView: 1,
      loop: thumbsLength > slidesPerViewInteger,
      loopedSlides: 5,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: thumbsLength <= slidesPerViewInteger ? thumbs : false
      }
    }
  );

  if (thumbsLength > slidesPerViewInteger) {
    slider.controller.control = thumbs;
    thumbs.controller.control = slider;
  }
}
